import React from "react";

import './App.css';
import LandingSection from './pages/LandingPage/LandingSection';
import Header from './common/Header';
import InfoSection from './pages/LandingPage/InfoSection';
import SampleSection from './pages/LandingPage/SampleSection';
import DownloadSection from "./pages/LandingPage/DownloadSection";
import Footer from "./common/Footer";
import AboutSection from "./pages/AboutSection";
import MediaCoverageSection from "./pages/LandingPage/MediaCoverage";
import PaperPublishedSection from "./pages/LandingPage/PaperPublished";

function App() {
  return (
    <div>
    <div className="App">

      <Header/>
      <LandingSection />
      <InfoSection/>
      <SampleSection/>
      <PaperPublishedSection/>
      <MediaCoverageSection/> 
      <AboutSection />
      <Footer/>

    </div>

    </div>
  );
}

export default App;


